/**
 * Voluum tracker lander GET/PUT (proxied).
 * For Media Devoted | Created By Ciro Autiero
 */

import api from '@/services/api';

const LANDER_FIELDS =
  'name,namePostfix,url,landerType,shouldHaveTrackingScript,numberOfOffers,preferredTrackingDomain,tags,country,workspace,note';

function unwrap<T>(data: unknown): T {
  if (data !== null && typeof data === 'object' && 'data' in data) {
    return (data as { data: T }).data;
  }
  return data as T;
}

export async function getVoluumLander(id: string): Promise<unknown> {
  const { data } = await api.get<unknown>(
    `/voluum/landers/${encodeURIComponent(id)}`,
    { params: { fields: LANDER_FIELDS } },
  );
  return unwrap<unknown>(data);
}

export async function updateVoluumLander(
  id: string,
  body: Record<string, unknown>,
): Promise<unknown> {
  const { data } = await api.put<unknown>(
    `/voluum/landers/${encodeURIComponent(id)}`,
    body,
  );
  return unwrap<unknown>(data);
}
